<!--
 * @Description: 
 * @Autor: yd
 * @Date: 2020-07-13 09:24:52
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-02-05 14:23:08
-->
<template>
  <div>
    <mrc_ess_iconGroup :is_disabled="readonly"
                       :showEdit="hasBtn('edit-email-template')"
                       :show_del="hasBtn('delete-email-template')"
                       :showReturn="false"
                       @handleEdit="handleEdit"
                       @handleDel="handleDel"></mrc_ess_iconGroup>

    <v-tabs v-model="tab"
            grow
            @change="tabchange"
            background-color="#eeeef0"
            color="primary"
            dark>
      <v-tab v-for="(item, index) in items"
             class="text-capitalize"
             :key="index">
        {{ item.tab }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item>
        <commoninfor :disabled="readonly"
                     @changeFunctionUuid='changeFunctionUuid'
                     @changeReadonly="handleEdit"></commoninfor>
      </v-tab-item>

      <v-tab-item>
        <emailtemplate :disabled="readonly"
                       ref="emailtemplate"
                       @changeReadonly="handleEdit"></emailtemplate>
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import commoninfor from './modules/commoninfor'
import emailtemplate from './modules/emailtemplate'
import {
  getemailtemplatelist,
  getdetailemailtemplate,
  deleteemailtemplate,
} from '@/service/api/emailtemplate'
export default {
  components: {
    commoninfor,
    emailtemplate,
  },
  props: {},
  data () {
    return {
      readonly: false,
      tab: 0,

      list: {},
    }
  },
  computed: {
    items () {
      return [
        { tab: this.$t('label_The_general_information') },
        { tab: this.$t('label_The_template') },
      ]
    },
  },
  created () { },
  watch: {
    readonly: {
      handler (v) {
        if (!this.$store.state.uuid) return
        if (!v) {
          this.$route.meta.title = 'label_edit_email_template'
          this.$store.commit('set_page_title', 'label_edit_email_template')
        }
        else {
          this.$route.meta.title = 'label_view_email_template'
          this.$store.commit('set_page_title', 'label_view_email_template')
        }
      }, immediate: true
    }
  },
  mounted () {
    this.readonly = this.$store.state.iconstatus
    this.tab = this.$store.state.tab
  },
  methods: {
    changeFunctionUuid () {
      this.$refs.emailtemplate ? this.$refs.emailtemplate.getdetail() : ''
    },
    tabchange () {
      this.$store.commit('setTab', this.tab)
    },
    handleEdit () {
      this.readonly = !this.readonly
      this.$store.commit('set_iconstatus', this.readonly)
    },
    handleDel () {
      this.$myConfirm({
        content: this.$t('message_Confirm_the_deletion'),
      }).then((res) => {
        deleteemailtemplate({ uuid: this.$store.state.uuid }).then((res) => {
          if (res.code == 200) {
            this.$Message({
              text: this.$t('message_The_deletion_was_successful'),
            })
            this.$router.push({
              name: 'emailtemplate',
              params: {
                type: 'del',
              },
            })
          }
        })
      })
    },
  },
}
</script>

<style scoped></style>
